import axios from 'axios';
import Cookies from 'universal-cookie';

const initialState = {
    config: null, // { id, defaultPct, updatedAt, updatedBy }
};

// Action Types
const GET_COMMISSION_CONFIG = 'GET_COMMISSION_CONFIG';
const UPDATE_COMMISSION_CONFIG = 'UPDATE_COMMISSION_CONFIG';

// Reducer
export default function CommissionConfigReducer(state = initialState, action) {
    switch (action.type) {
        case GET_COMMISSION_CONFIG:
        case UPDATE_COMMISSION_CONFIG:
            return { ...state, config: action.payload };
        default:
            return state;
    }
}

// Action Creators
export const SetCommissionConfig = (config) => ({ type: GET_COMMISSION_CONFIG, payload: config });
export const SetCommissionConfigUpdated = (config) => ({ type: UPDATE_COMMISSION_CONFIG, payload: config });

const getHeaders = () => {
    const cookies = new Cookies();
    return { headers: { Authorization: `Bearer ${cookies.get('token')}` } };
};

// Thunks (proxy /api/admin/commission-config en EasyLawyer; solo Super-Admin)
export const fetchCommissionConfigFromAPI = () => async (dispatch) => {
    try {
        const response = await axios.get(window.API_BASE_URL + '/admin/commission-config', getHeaders());
        dispatch(SetCommissionConfig(response.data));
    } catch (error) {
        console.error('Error fetching commission config:', error);
    }
};

export const updateCommissionConfigInAPI = (defaultPct) => async (dispatch) => {
    const response = await axios.put(window.API_BASE_URL + '/admin/commission-config', { defaultPct }, getHeaders());
    dispatch(SetCommissionConfigUpdated(response.data));
    return response.data;
};
